import React from "react";
import { NoModuleRights, RoleRightsForModule } from "../../utils/utils";

const SettingSideMenu = ({ subCategories, setSubCategories }) => {
  return (
    <div className="leftlang-box">
      {!NoModuleRights("Profile") && (
        <div
          className={`lang-heading ${
            subCategories === "profile" ? "active" : ""
          }`}
          onClick={() => setSubCategories("profile")}
        >
          <p>Profile</p>
        </div>
      )}
      {!NoModuleRights("Manage Projects") && (
        <div
          className={`lang-heading ${
            subCategories === "manageProjects" ? "active" : ""
          }`}
          onClick={() => setSubCategories("manageProjects")}
        >
          <p>Manage Projects</p>
        </div>
      )}
      {/* <div className='lang-heading'>
                <p>Privacy</p>
            </div> */}
      <div
        className={`lang-heading ${subCategories === "share" ? "active" : ""}`}
        onClick={() => setSubCategories("share")}
      >
        <p>Share</p>
      </div>
      {/* <div
        className={`lang-heading ${subCategories === "summaryPrompts" ? "active" : ""}`}
        onClick={() => setSubCategories("summaryPrompts")}
      >
        <p>Summary Prompts</p>
      </div> */}
      <div
        className={`lang-heading ${subCategories === "personas" ? "active" : ""}`}
        onClick={() => setSubCategories("personas")}
      >
        <p>Personas</p>
      </div>
      <div
        className={`lang-heading ${subCategories === "chatSettings" ? "active" : ""}`}
        onClick={() => setSubCategories("chatSettings")}
      >
        <p>Chat Settings</p>
      </div>
      <div
        className={`lang-heading ${subCategories === "tones" ? "active" : ""}`}
        onClick={() => setSubCategories("tones")}
      >
        <p>Tones</p>
      </div>
    </div>
  );
};

export default SettingSideMenu;
